import { render, staticRenderFns } from "./CreatePV.vue?vue&type=template&id=4472a426&scoped=true&lang=pug"
import script from "./CreatePV.vue?vue&type=script&lang=js"
export * from "./CreatePV.vue?vue&type=script&lang=js"
import style0 from "./CreatePV.vue?vue&type=style&index=0&id=4472a426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472a426",
  null
  
)

export default component.exports